import React from 'react';
import { Alert } from 'antd';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import { Dictionary } from './constants/style.constant';

import './styles.scss';

export default function CustomAlert(props) {
	const country = props.country || Enviroment.LANGUAGE;
	return <Alert {...props} className={Dictionary[country][props.className]} />;
}
